import { COUNTRIES } from "../../constants/countries";
import {
  IAuthContextState,
  IAuthContextUser,
  IDecodedJWTToken,
  userRoles,
} from "./AuthProvider.types";

export const defaultDecodedJWTToken: IDecodedJWTToken = {
  LOGO: "",
  COMPANY_NAME: "",
  company_outlet_uuid: "",
  full_name: "",
  user_fact_unique_id: 0,
  user_uuid: "",
  company_outlet_timezone: "",
  email: "",
  role_uuid: "",
  role_value: "",
  branch_uuid: [],
  internal_enr_user: {},
  iat: 0,
  exp: 0,
  gst_percentage: "",
  default_country: ""
};

export const defaultAuthUser: IAuthContextUser = {
  first_name: "",
  last_name: "",
  full_name: "",
  name: "",
  email: "",
  userId: 0,
  role: userRoles.None,
  userUuid: "",
  role_value: "",
  mobile: "",
  affilated_company_outlet_uuids: [],
  shared_emails: []
};

export const defaultAuthState: IAuthContextState = {
  user: defaultAuthUser,
  twoFactorData: {
    userFactId: 0,
  },
  app_info: {
    company_name: "",
    company_logo: "",
  },
  isLogin: false,
  token: null,
  sessionCount: 0,
  company_outlet_timezone: "",
  date: new Date(),
  force_logout: false,
  subscribed_plan: null,
  security: [],
  gst_percentage: "",
  external_auth: null,
  userSettings: [],
  isSimDialingEnabled: true,
  country: COUNTRIES[0]
};
